export const workersQuantityRouting = [
  {
    path: "/labor/workersQuantity/list",
    name: "labor-workers-quantity-list",
    meta: { title: "上工人数" },
    component: () => import("@/views/labor/workers-quantity/list/index.vue"),
  },
];
